import * as Types from '../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type CustomerMarketingStatusQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']
}>

export type CustomerMarketingStatusQuery = {
  customerMarketingStatus: {
    __typename: 'CustomerMarketingStatus'
    optOutMarketingSMS: boolean
    optOutMarketingEmail: boolean
    maskedPhoneNumber: string
    maskedEmail: string
  }
}

export const CustomerMarketingStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomerMarketingStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerMarketingStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optOutMarketingSMS' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optOutMarketingEmail' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'maskedPhoneNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'maskedEmail' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerMarketingStatusQuery,
  CustomerMarketingStatusQueryVariables
>
